<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="card">
          <div class="card-header header-elements-inline">
            <h5 class="card-title">Manage Customers</h5>
          </div>
          <div class="card-body">
            <el-button
              type="primary"
              size="medium"
              style="float: right"
              class="mb-4"
              @click="() => (showModal = true)"
              >Add Customer</el-button
            >
            <!-- TABLE -->
            <el-table :data="tableData">
              <el-table-column label="Edit" width="180">
                <template slot-scope="scope">
                  <el-dropdown
                    class="inlineButton"
                    trigger="click"
                    @command="handleCommand"
                    size="small"
                  >
                    <el-button type="primary">
                      <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        icon="el-icon-edit"
                        :command="{
                          action: 'edit',
                          data: scope.row,
                          index: scope.$index
                        }"
                        >Edit</el-dropdown-item
                      >
                      <el-dropdown-item
                        icon="el-icon-delete"
                        divided
                        :command="{
                          action: 'delete',
                          data: scope.row,
                          index: scope.$index
                        }"
                        >Delete</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
              <el-table-column prop="displayName" label="Name" sortable>
              </el-table-column>
            </el-table>
          </div>

          <!-- ADD CUSTOMER MODAL -->

          <el-dialog
            :visible.sync="showModal"
            @closed="clearCustomer"
            class="custom-el-modal"
          >
            <h6 slot="title">
              {{ editModal ? 'Edit Customer' : 'Add Customer' }}
            </h6>
            <span class="form-group">
              <el-form label-position="left" class="validationError">
                <el-form-item label="Customer Name:">
                  <el-input
                    type="text"
                    id="name"
                    name="name"
                    style="width:50%"
                    maxlength="25"
                    show-word-limit
                    v-model="selectedCustomer.name"
                    class="el-dark-input"
                  />
                </el-form-item>
              </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showModal = false">Cancel</el-button>
              <el-button v-if="!editModal" type="primary" @click="addCustomer"
                >Confirm</el-button
              >
              <el-button v-else type="primary" @click="editCustomer"
                >Edit</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '../../assets/js/firebase/db.js';

export default {
  name: 'manageCustomers',
  components: {},
  props: {
    tableData: Array
  },
  data() {
    return {
      showModal: false,
      editModal: false,
      selectedCustomer: {
        name: null
      }
    };
  },
  methods: {
    //handles the command from the dropdown(either edit or delete)
    handleCommand(data) {
      //if command is delete, delete customer
      if (data.action === 'delete') {
        try {
          db.collection('customers')
            .doc(data.data.id)
            .update({ deleted: true })
            .then(() => {
              // let index = this.tableData
              this.tableData.splice(data.index, 1);
              this.showSuccess('Customer successfully deleted');
            });
        } catch (error) {
          this.showError('Error deleting customer');
          console.log(error);
        }
        //if command is edit, populate the modal and open it
      } else if (data.action === 'edit') {
        this.editModal = true;
        this.populateModal(data.data);
        this.showModal = true;
      }
    },
    populateModal(data) {
      this.selectedCustomer = {
        name: data.displayName,
        id: data.id
      };
    },
    addCustomer() {
      if (this.validateEntry()) {
        try {
          //format the data from the modal before we send to firebase
          let formattedData = {
            displayName: this.selectedCustomer.name.trim(),
            customerName: this.selectedCustomer.name.trim().toLowerCase(),
            org: this.$store.state.userCompany,
            deleted: false
          };
          //send the formatted data to firebase
          db.collection('customers')
            .add(formattedData)
            .then(doc => {
              //edit the table to show new data
              formattedData['id'] = doc.id;
              this.tableData.push(formattedData);
              this.showModal = false;
              this.showSuccess('Customer successfully added');
            });
        } catch (error) {
          console.log(error);
          this.showError('Error adding customer');
        }
      } else {
        this.showError('Please fill out form entirely');
      }
    },
    editCustomer() {
      if (this.validateEntry()) {
        try {
          //format the data from the modal before we send to firebase
          let formattedData = {
            displayName: this.selectedCustomer.name.trim(),
            customerName: this.selectedCustomer.name.trim().toLowerCase(),
            org: this.$store.state.userCompany,
            deleted: false
          };
          //send the formatted data to firebase

          db.collection('customers')
            .doc(this.selectedCustomer.id)
            .update(formattedData)
            .then(() => {
              //edit the table to show new data
              formattedData['id'] = this.selectedCustomer.id;
              let index = this.tableData.findIndex(
                x => x.id === this.selectedCustomer.id
              );

              this.tableData.splice(index, 1, formattedData);
              this.showModal = false;
              this.showSuccess('Customer succesfully updated');
            });
        } catch (error) {
          this.showError('Error updating customer');

          console.log(error);
        }
      } else {
        this.showError('Please fill out form entirely');
      }
    },
    clearCustomer() {
      this.editModal = false;
      this.selectedCustomer = {
        name: null
      };
    },
    //validate modal entry
    //TODO: highlight where validation errors are in the modal
    validateEntry() {
      if (
        this.selectedCustomer.name === null ||
        this.selectedCustomer.name.trim() === ''
      ) {
        return false;
      }
      return true;
    },

    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    }
  }
};
</script>
<style>
/* TODO: improve visuals of modal */
.el-dialog__header {
  background-color: #ad466c;
}
.el-dialog__body {
  background-color: #353f53;
}
.el-dialog__footer {
  background-color: #353f53;
}
.el-form-item__label {
  color: white !important;
}
/* .el-switch__core.is-checked {
  background-color: #ad466c !important;
  border-color: #ad466c !important;
} */
.el-switch__label {
  /* color: white !important; */
  color: #ad466c !important;

  /* font-size: 30px !important; */
  position: relative;
  /* width: 10%; */
  display: inline-block;
  vertical-align: middle;
}
.el-switch__label.is-active {
  color: #ad466c !important;
  /* -webkit-text-stroke-width: 0.4px;
  -webkit-text-stroke-color: white; */
}
.onoffswitch {
  /* background-color: #ad466c !important; */
  color: #ad466c !important;
  position: relative;
  /* width: 25%; */
  display: inline-block;
  /* vertical-align: middle; */
}
.validationError {
  border-color: red;
  border-width: thick;
}
.el-table tr {
  background-color: #353f53 !important;
  color: white !important;
}
.el-table th {
  background-color: #353f53 !important;
  color: white !important;
}
.el-table tr:hover {
  background-color: blue !important;
  background: red;
}
.el-table td {
  background-color: #353f53 !important;
}
</style>
